import { render, staticRenderFns } from "./CommentInfo.vue?vue&type=template&id=f26b010a&scoped=true&"
import script from "./CommentInfo.vue?vue&type=script&lang=js&"
export * from "./CommentInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommentInfo.vue?vue&type=style&index=0&id=f26b010a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26b010a",
  null
  
)

export default component.exports